import { NgModule } from '@angular/core'
import { EbBreadcrumbModule } from '../components/breadcrumb/eb-breadcrumb.module'
import { EbAsmModule } from './asm/eb-asm.module'
import { EbAuthModule } from './auth/eb-auth.module'
import { EbCartModule } from './cart/eb-cart.module'
import { EbCheckoutModule } from './checkout/eb-checkout.module'
import { EbCmsModule } from './cms/eb-cms.module'
import { EbConfigModule } from './config/eb-config.module'
import { EbFavoritesModule } from './favorites/eb-favorites.module'
import { EbFooterModule } from './footer/eb-footer.module'
import { EbFormModule } from './form/eb-form.module'
import { EbGlobalMessageModule } from './global-message/eb-global-message.module'
import { EbHeaderModule } from './header/eb-header.module'
import { EbI18nModule } from './i18n/eb-i18n.module'
import { EbMyAccountModule } from './myaccount/eb-my-account.module'
import { EbOrderFeatureModule } from './order/eb-order-feature.module'
import { EbProductModule } from './product/eb-product.module'
import { EbSeoModule } from './seo/eb-seo.module'
import { EbSiteContextModule } from './site-context/eb-site-context.module'
import { EbSupportModule } from './support/eb-support.module'
import { EbUserModule } from './user/eb-user.module'

@NgModule({
  imports: [
    EbAsmModule,
    EbSiteContextModule,
    EbFooterModule,
    EbHeaderModule,
    EbCartModule,
    EbProductModule,
    EbUserModule,
    EbCheckoutModule,
    EbAuthModule,
    EbSupportModule,
    EbFormModule,
    EbMyAccountModule,
    EbGlobalMessageModule,
    EbCmsModule,
    EbBreadcrumbModule,
    EbConfigModule,
    EbOrderFeatureModule,
    EbFavoritesModule,
    EbSeoModule,
    EbI18nModule.forRoot()
  ]
})
export class EbFeaturesModule {}
